// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f4c7b947","885":"2e757b3a"}[chunkId] + ".chunk.js";
};